import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { lotService } from "../services/svc_lots";
import { queryKeys } from "../lib/queryKeys";
import { ListRequest, ListRequestSchemaV2 } from "../types/common/commonTypes";

export const useTSQLotList = (params: ListRequest, enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.lot.list(params),
    queryFn: () => lotService.list(params),
    placeholderData: keepPreviousData,
    enabled: enabled,
  });
};

export const useTSQLotListView = (
  params: ListRequestSchemaV2,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: queryKeys.lot.listv2(params, "list_view"),
    queryFn: () => lotService.listv2(params),
    // placeholderData: keepPreviousData,
    enabled: enabled,
  });
};

export const useTSQLotListPalletLots = (enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.lot.listv2(null, "work_orders"),
    queryFn: () => lotService.listPalletLots(),
    enabled: enabled,
  });
};

export const useTSQLot = (id: string | null) => {
  return useQuery({
    queryKey: queryKeys.lot.detail(id!),
    queryFn: () => {
      return lotService.getById(id!);
    },
    enabled: !!id,
  });
};

export const useTSQLotByNum = (num: string | null, enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.lot.detail(num!),
    queryFn: () => {
      return lotService.getByNum(num!);
    },
    enabled: !!num && enabled,
  });
};

export const useTSMCreateLot = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: lotService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.lot.lists() });
    },
    onError: (error) => {
      console.error("Failed to create Lot:", error);
    },
  });
};

export const useTSMUpdateLot = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      lotService.update(id, data),
    onSuccess: (updatedLot) => {
      queryClient.setQueryData(queryKeys.lot.detail(updatedLot.id), updatedLot);
      queryClient.invalidateQueries({ queryKey: queryKeys.lot.lists() });
    },
    onError: (error) => {
      console.error("Failed to update Lot:", error);
    },
  });
};

export const useTSMDeactivateLot = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: lotService.deactivate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.lot.lists() });
    },
    onError: (error) => {
      console.error("Failed to deactivate Lot:", error);
    },
  });
};

export const useTSMReactivateLot = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: lotService.reactivate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.lot.lists() });
    },
    onError: (error) => {
      console.error("Failed to reactivate Lot:", error);
    },
  });
};
